export const socialLinks = [
	{
		id: 2,
		name: 'GitHub',
		icon: 'github',
		url: 'https://github.com/IngeniumInstruo',
	},
	{
		id: 4,
		name: 'LinkedIn',
		icon: 'linkedin',
		url: 'https://www.linkedin.com/in/marcelino-bonifacio-3646ba263',
	}
];
